import React from "react";
import { Accordion, AccordionContent } from "../../../../components/accordion";
import { t } from "../../../../core/translate";
import { StyledAccordionButton, StyledCaret, ThemedList } from "./styles";
import { ToolsIcon } from "./styles";
import {
  redeemCodes,
  updateLicense,
  sharing,
  highlighters
} from "../menu-items/tools";

export default ({ headingLevel }) => {
  const data = [
    {
      listItems: [
        redeemCodes(),
        updateLicense(),
        sharing(),
        highlighters()
      ].filter(el => !!el)
    }
  ];
  return (
    <Accordion>
      <StyledAccordionButton level={headingLevel}>
        <ToolsIcon color="white" smallMargin viewBox="0 -6 36 36" />
        {t("global-bar.tools", "Tools")}
        <StyledCaret />
      </StyledAccordionButton>
      <AccordionContent>
        <ThemedList data={data} />
      </AccordionContent>
    </Accordion>
  );
};
